import React, { useEffect, useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { ModalName } from '../../../constants/ModalName';
import { useModal, useModalHandlersAndOptions } from '../../../utils/hooks/useModal';
import { Text, Thumbnail } from '@wix/design-system';
import { contains, filter } from 'ramda';
import styles from './recommendedModal.scss';

type Topic = {
  id: string;
  imageUrl: string;
  title: string;
};

const THUMB_SIZE = '106px';

export const useRecommendedCategoriesModal = (preselectedTopics: string[]) => {
  const { formatMessage } = useIntl();
  const [selectedTopics, setSelectedTopics] = useState<string[]>(preselectedTopics);

  useEffect(() => {
    if (preselectedTopics.length > 0) {
      setSelectedTopics(preselectedTopics);
    }
  }, [preselectedTopics]);

  return useModal(ModalName.RecommendedCategories, {
    customLayout: true,
    width: '700px',
    title: formatMessage({ id: 'media-home.recommendation-section.feedback.title' }),
    content: ({ additionalOptions: { recommendedTopics = [] } }) => {
      return (
        <>
          <Text>
            <FormattedMessage id="media-home.recommendation-section.feedback.sub-title" />
          </Text>

          <div className={styles.container}>
            {(recommendedTopics as Topic[]).map((topic) => (
              <div style={{ gridArea: 'span 1 / span 3' }} key={topic.id}>
                <Thumbnail
                  backgroundImage={topic.imageUrl}
                  title={topic.title}
                  selected={contains(topic.id, selectedTopics)}
                  width={THUMB_SIZE}
                  height={THUMB_SIZE}
                  onClick={() => {
                    contains(topic.id, selectedTopics)
                      ? setSelectedTopics(filter((s) => s !== topic.id, selectedTopics))
                      : setSelectedTopics([...selectedTopics, topic.id]);
                  }}
                />
              </div>
            ))}
          </div>
        </>
      );
    },
    hideFooter: false,
    shouldCloseOnOverlayClick: true,
    noBodyPadding: false,
    confirmText: formatMessage({ id: 'media-home.recommendation-section.feedback.apply-button' }),
    cancelText: formatMessage({ id: 'media-home.recommendation-section.feedback.cancel-button' }),
    onOk: ({ additionalOptions: { updateTopics } }) => {
      updateTopics(selectedTopics);
    },
  });
};

export const useRecommendedCategoriesModalHandlers = () => useModalHandlersAndOptions(ModalName.RecommendedCategories);
